import { render, staticRenderFns } from "./id-face-exam.vue?vue&type=template&id=359ddeb3&scoped=true"
import script from "./id-face-exam.vue?vue&type=script&lang=ts"
export * from "./id-face-exam.vue?vue&type=script&lang=ts"
import style0 from "./id-face-exam.vue?vue&type=style&index=0&id=359ddeb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ddeb3",
  null
  
)

export default component.exports